import AppService from './AppService';

class UsZipsService extends AppService {
  constructor() {
    super();
    this.path = this.getPath('us-zips');
  }


  zipCode(id) {
    return this.http.get(`${this.path}/${id}`);
  }

}

export default UsZipsService;
